export const BASE_URL =
  process.env.REACT_APP_ENV === "DEV"
    ? `https://demo.h2hdigitalrx.com/`
    : process.env.REACT_APP_ENV === "PROD"
    ? `https://www.h2hdigitalrx.com/`
    : process.env.REACT_APP_ENV === "STAGE"
    ? `https://drxstage.h2hdigitalrx.com/`
    : process.env.REACT_APP_ENV === "DEMO"
    ? `https://demo.h2hdigitalrx.com/`
    : `https://partners-dev.h2hdigitalrx.com/`;

export const REPORT_BASE_URL =
  process.env.REACT_APP_ENV === "PROD"
    ? "https://www.h2hdigitalrx.com/"
    : "https://drxstage.h2hdigitalrx.com/";

export const IDME_URL_DOMAIN =
  process.env.REACT_APP_ENV === "PROD" ? "idme" : "idtest2";

export const IDME_URL_END =
  process.env.REACT_APP_ENV === "PROD"
    ? "prod"
    : process.env.REACT_APP_ENV === "DEV"
    ? "dev"
    : process.env.REACT_APP_ENV === "STAGE"
    ? "stage"
    : process.env.REACT_APP_ENV === "DEMO"
    ? "demo"
    : "partners";

export const IDME_WITHIN_DRX_URL =
  process.env.REACT_APP_ENV === "PROD"
    ? "https://api.id.me/api/auth/v1/multifactor/"
    : "https://api.idmelabs.com/api/auth/v1/multifactor/";
